import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class CreateUserErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [
                {
                    'code': 'unexpected_error_code',
                    'text': 'User already exists'
                }
            ]
        }
    }

    static errorCodes() {
        return ['duplicated_user'];
    }
}